import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://rxvnehbfbfzfqydsrgqb.supabase.co'
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ4dm5laGJmYmZ6ZnF5ZHNyZ3FiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzIyMDQ5MjksImV4cCI6MjA0Nzc4MDkyOX0.FzyRedMP24wntfDCdlYdGBZMn8Xg7N8-X3DoGL4SHXk'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
